import { render, staticRenderFns } from "./widget-loader.vue?vue&type=template&id=086074a7&scoped=true&"
import script from "./widget-loader.vue?vue&type=script&lang=js&"
export * from "./widget-loader.vue?vue&type=script&lang=js&"
import style0 from "./widget-loader.vue?vue&type=style&index=0&id=086074a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086074a7",
  null
  
)

export default component.exports